import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Home from "./pages/Home";
import Questionnaire from "./pages/Questionnaire";
import Results from "./pages/Results";
import Stage2Questionnaire from "./pages/Stage2Questionnaire";
import Stage2Results from "./pages/Stage2Results";
import ExploreCareers from "./pages/ExploreCareers";
import CompareCareers from "./pages/CompareCareers";
import AdminDashboard from "./pages/AdminDashboard";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import FormationsPage from "./pages/FormationsPage";
import NationalObservatory from "./pages/NationalObservatory";
import AuditDashboard from "./pages/AuditDashboard";
import AdvocacyPage from "./pages/AdvocacyPage";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/questionnaire" element={<Questionnaire />} />
          <Route path="/results" element={<Results />} />
          <Route path="/stage2" element={<Stage2Questionnaire />} />
          <Route path="/stage2-results" element={<Stage2Results />} />
          <Route path="/explore" element={<ExploreCareers />} />
          <Route path="/compare" element={<CompareCareers />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/formations" element={<FormationsPage />} />
          <Route path="/observatory" element={<NationalObservatory />} />
          <Route path="/audit" element={<AuditDashboard />} />
          <Route path="/plaidoyer" element={<AdvocacyPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
